import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.homework.classcommentlist;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
};

export { ActionTypes };
